import Parse from 'parse';
import { singleEntityLoading } from '../mixins/loading-states';
/**
 * @class SystemApplicationsModule
 */
const SystemApplicationsModule = {
  namespaced: true,
  state: {
    ...singleEntityLoading.state,
    applications: null,
  },
  mutations: {
    ...singleEntityLoading.mutations,
    setApplications(state, applications) {
      state.applications = applications;
    },
  },
  actions: {
    ...singleEntityLoading.actions,
    loadSystemApplications({ state, commit, rootState }) {
      commit('setLoading');
      let query = new Parse.Query('SystemApplication');
      query.include('systems');
      query.addAscending('name');
      query.equalTo('language', rootState.user.language);
      query.equalTo('visible', true);

      return query.find().then((response) => {
        commit('setApplications', response);
        commit('setLoaded');
      });
    },
  },
  getters: {
    ...singleEntityLoading.getters,
    systemApplications: (state) => state.applications || [],
  },
};

export default SystemApplicationsModule;
